import { z } from 'zod';

export const userRoleSchema = z.enum([
  'client',
  'admin',
  'super_admin',
  'technicien',
  'partenaire',
]);
export type UserRole = z.infer<typeof userRoleSchema>;

export const clientTypeSchema = z.enum([
  'particulier',
  'entreprise',
  'promoteur',
  'amenageur',
  'copropriete',
  // Professionnels & collectivités (cf. Module Professionnels & Collectivités).
  'syndic',
  'sci',
  'collectivite',
  'mairie',
  'administration',
  'architecte',
  'bureau_etudes',
]);
export type ClientType = z.infer<typeof clientTypeSchema>;

export const requestTypeSchema = z.enum([
  'etude_raccordement',
  'point_raccordement',
  'travaux_fibre',
  'previsite_technique',
  'reparation_sav',
  'devis_travaux_divers',
  'securisation_fibre',
  'enfouissement_cables',
]);
export type RequestType = z.infer<typeof requestTypeSchema>;

export const typologySchema = z.enum([
  'maison_individuelle',
  'appartement',
  'logement_collectif',
  'locaux_pro',
  'batiment_a_renover',
  'lotissement',
  'promoteur',
  'amenageur',
  'entreprise',
  // Professionnels & collectivités.
  'villa',
  'immeuble_collectif',
  'residence',
  'commerce',
  'batiment_public',
  'zone_activite',
]);
export type Typology = z.infer<typeof typologySchema>;

/** Nature du projet (segment professionnels & collectivités). */
export const projectNatureSchema = z.enum([
  'construction_neuve',
  'renovation',
  'rehabilitation',
  'extension',
  'division_immobiliere',
  'changement_usage',
  'mise_en_conformite',
  'autre',
]);
export type ProjectNature = z.infer<typeof projectNatureSchema>;

/** Prestations demandées (segment professionnels & collectivités). */
export const proPrestationSchema = z.enum([
  'previsite_technique',
  'etude_raccordement',
  'precablage_telecom',
  'recherche_par',
  'mise_en_conformite_operateur',
  'chiffrage_travaux',
  'realisation_travaux',
  'accompagnement_attestation',
]);
export type ProPrestation = z.infer<typeof proPrestationSchema>;

export const unitTypeSchema = z.enum([
  't1',
  't2',
  't3',
  't4',
  'maison',
  'bureau',
  'commerce',
  'entrepot',
]);
export type UnitType = z.infer<typeof unitTypeSchema>;

export const documentTypeSchema = z.enum([
  'piece_identite',
  'permis_construire',
  'attestation_adressage',
  'plans_architecte',
  'photo_interieur',
  'photo_exterieur',
  'photo_installation',
  // Professionnels & collectivités.
  'plan_masse',
  'plans_vrd',
  'courrier_operateur',
  'autre',
]);
export type DocumentType = z.infer<typeof documentTypeSchema>;

export const documentStatusSchema = z.enum([
  'en_attente',
  'valide',
  'refuse',
  'a_completer',
]);
export type DocumentStatus = z.infer<typeof documentStatusSchema>;

export const paymentMethodSchema = z.enum(['carte', 'virement']);
export type PaymentMethod = z.infer<typeof paymentMethodSchema>;

export const paymentStatusSchema = z.enum([
  'en_attente',
  'paye',
  'echec',
  'rembourse',
]);
export type PaymentStatus = z.infer<typeof paymentStatusSchema>;

export const projectStatusSchema = z.enum([
  'compte_cree',
  'projet_renseigne',
  'demande_qualifiee',
  'documents_deposes',
  'en_verification_bcl',
  'dossier_valide',
  'paiement_valide',
  'pris_en_charge',
  'analyse_en_cours',
  'previsite_planifiee',
  'intervention_realisee',
  'compte_rendu_disponible',
  'travaux_en_cours',
  'termine',
  // Statut terminal d'archivage : BCL a clôturé le dossier (rapport consulté,
  // dossier soldé). Le dossier sort du kanban mais reste dans la liste.
  'cloture',
]);
export type ProjectStatus = z.infer<typeof projectStatusSchema>;

export const packCodeSchema = z.enum([
  'serenite_fibre',
  'essentiel_fibre',
  'confort_fibre',
  'remise_en_conformite_sav',
]);
export type PackCode = z.infer<typeof packCodeSchema>;

export const connectionTypeSchema = z.enum(['aerien', 'souterrain', 'inconnu']);
export type ConnectionType = z.infer<typeof connectionTypeSchema>;

/** Réponse tri-état (ex : « la fibre est-elle présente devant la propriété ? »). */
export const fiberPresenceSchema = z.enum(['oui', 'non', 'je_ne_sais_pas']);
export type FiberPresence = z.infer<typeof fiberPresenceSchema>;
